export default __webpack_public_path__ + "static/media/graduate.7ac09258.svg";